module.exports = __webpack_public_path__ + "img/lianjie.2308903a.png";